import React, { useState } from 'react';
import { Transition } from '@headlessui/react';
import { InformationCircleIcon as InfoIcon } from '@heroicons/react/24/outline';

export interface InfoProps {
  children?: React.ReactNode;
  message: string;
  panelClassName?: string;
}

const DEFAULT_PANEL_CLASS_NAME =
  'absolute right-0 top-1/2 w-max max-w-260 -translate-y-1/2 translate-x-[calc(100%+24px)] rounded-md border border-custom-processing bg-site p-12';

const Info: React.FC<InfoProps> = ({ message, panelClassName }) => {
  const [isShowing, setIsShowing] = useState(false);

  return (
    <div className="relative" data-testid="atom-info">
      <button
        type="button"
        className="cursor-default border-0 bg-transparent p-0"
        aria-label="Show information"
        data-testid="atom-info-trigger"
        onMouseOver={() => setIsShowing(true)}
        onMouseOut={() => setIsShowing(false)}
        onFocus={() => setIsShowing(true)}
        onBlur={() => setIsShowing(false)}
      >
        <InfoIcon className="size-24 stroke-secondary-regular" aria-hidden="true" />
      </button>
      <Transition
        show={isShowing}
        className={panelClassName ?? DEFAULT_PANEL_CLASS_NAME}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <p className="text-12 leading-[15px] text-secondary-regular" data-testid="atom-info-message">
          {message}
        </p>
      </Transition>
    </div>
  );
};

export default Info;
